<template>
  <div class="brand">
    <span>{{ brandName }}</span> - 管理控制台
  </div>
</template>

<script>
export default {
  computed: {
    brandName() {
      return this.$store.state.user.customer.brand_name
    }
  }
}
</script>

<style lang="scss">
.brand {
  padding-left:10px;
  font-size:18px;
  font-weight:bold;
  color:#fff;
  line-height:46px;
}
</style>
